/* 🤖 this file was generated by svg-to-ts */
export const siriusTag: {
  name: 'tag';
  data: string;
} = {
  name: 'tag',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style="display: block;"><path d="M22.81 12.75 13.5 3.44A1.487 1.487 0 0 0 12.44 3H3.75a.75.75 0 0 0-.75.75v8.69a1.486 1.486 0 0 0 .44 1.06l9.31 9.31a1.5 1.5 0 0 0 2.122 0l7.938-7.938a1.5 1.5 0 0 0 0-2.122Zm-9 9L4.5 12.44V4.5h7.94l9.31 9.31-7.94 7.94ZM9 7.875a1.125 1.125 0 1 1-2.25 0 1.125 1.125 0 0 1 2.25 0Z" fill="currentColor"/></svg>`
};
